import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { EditRounded } from "@material-ui/icons";
import PropTypes from "prop-types";
import { deleteFavouriteCpt } from "Redux/Rounding/rounding.actions";
import "./style.css";

function FavCptDialog(props) {
  let providerId = parseInt(localStorage.getItem("providerId"));
  const [favCptList, setFavCptList] = useState([]);
  const [isDeleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  useEffect(() => {
    if (
      props.roundingData &&
      props.roundingData.favouriteCptListRes &&
      props.roundingData.favouriteCptListRes.response
    ) {
      if (props.roundingData.favouriteCptListRes.response.responseCode === 0) {
        let data = props.roundingData.favouriteCptListRes.response.data;
        setFavCptList(data);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.roundingData.favouriteCptListRes.response]);

  const handleDelete = (x, i) => {
    setItemToDelete(x);
    setDeleteConfirmationOpen(true);
  };

  const confirmDelete = () => {
    if (itemToDelete) {
      props.deleteFavouriteCpt({
        providerId: providerId,
        cptCode: itemToDelete.cptCode,
      });
      setDeleteConfirmationOpen(false);
      const updatedList = favCptList.filter(
        (item) => item.cptCode !== itemToDelete.cptCode
      );
      setFavCptList(updatedList);
    }
  };

  const cancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };

  const handleCheckbox = (e, i) => {
    let r = favCptList;
    r[i] = { ...r[i], isSelected: e.target.checked };
    setFavCptList([...r]);
    const a = favCptList.filter((item) => item.isSelected);
    props.onSelectionChange(a);
  };

  return (
    <>
      <Dialog open={props.open} onClose={props.onClose}>
        <div className="cpt_favourites_container">
          <div
            style={{
              // fontSize: "18px",
              // fontWeight: "600",
              // paddingBottom: "1.5rem",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                fontSize: "18px",
                fontWeight: "600",
                paddingBottom: "1.5rem",
              }}
            >
              ICD Favorites
            </Typography>
            {/* <CloseIcon
              onClick={() => props.onClose()}
              style={{ cursor: "pointer" }}
            /> */}
            <div className="button_container1">
              <Button
                onClick={() => props.onClose()}
                variant="outlined"
                color="primary"
                style={{ marginRight: "10px" }}
              >
                Cancel
              </Button>{" "}
              <Button
                variant="contained"
                color="primary"
                type="submit"
                style={{ color: "white" }}
                onClick={() => props.onClose()}
              >
                Submit
              </Button>
            </div>
          </div>
          <div className="favCptListContainer">
            {favCptList.length ? (
              favCptList.map((x, i) => (
                <div className="favCptList">
                  <div className="favCptCheckbox">
                    <Checkbox
                      color="primary"
                      size="small"
                      onChange={(e) => handleCheckbox(e, i)}
                    />
                  </div>
                  <div className="favCptCode">{x.cptCode}</div>
                  <div className="favCptIcons">
                    {/* <EditRounded /> */}
                    <CloseIcon onClick={(e) => handleDelete(x, i)} />
                  </div>
                </div>
              ))
            ) : (
              <></>
            )}
          </div>
          {/* <div className="button_container">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            style={{ color: "white", marginRight: "10px" }}
          >
            Save
          </Button>
          <Button
            onClick={() => props.onClose()}
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
        </div> */}
        </div>
      </Dialog>

      <Dialog
        open={isDeleteConfirmationOpen}
        onClose={cancelDelete}
        aria-labelledby="delete-confirmation-dialog-title"
      >
        <DialogTitle id="delete-confirmation-dialog-title">
          Confirm Delete
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            No
          </Button>
          <Button onClick={confirmDelete} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
const mapStateToProps = (state) => ({
  roundingData: state.rounding,
});

const mapDispatchToProps = (dispatch) => ({
  deleteFavouriteCpt: (values) => dispatch(deleteFavouriteCpt(values)),
});
FavCptDialog.propTypes = {
  deleteFavouriteCpt: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(FavCptDialog);
